import { Box } from "ui/box/box";
import { mergeSx } from "ui/merge-sx";

import {
  DIALOG_ACTIONS_GROUP_SX,
  DIALOG_ACTIONS_SX_BY_TYPE,
} from "ui/dialog/dialog-actions/dialog-actions.styles";
import { type DialogActionsProps } from "ui/dialog/dialog-actions/dialog-actions.types";

export const DialogActions = ({
  type = "generic",
  primary,
  secondary,
  back,
  sx,
  ...rest
}: DialogActionsProps) => {
  if (type === "steps" && back) {
    return (
      <Box {...rest} sx={mergeSx(DIALOG_ACTIONS_SX_BY_TYPE.steps, sx)}>
        {back}
        <Box sx={DIALOG_ACTIONS_GROUP_SX}>
          {secondary}
          {primary}
        </Box>
      </Box>
    );
  }

  const isTrailing = type !== "generic";

  return (
    <Box {...rest} sx={mergeSx(DIALOG_ACTIONS_SX_BY_TYPE[isTrailing ? "process" : "generic"], sx)}>
      {isTrailing ? secondary : primary}
      {isTrailing ? primary : secondary}
    </Box>
  );
};
